const createCarePlan = (memberId) => {
  window.open(`/members/${memberId}/care_plans/new`);
  return true;
};

export default createCarePlan;
